export const PLAYLIST_COLORS: Record<string, { label: string; value: string }> = {
  red: { label: "Red", value: "oklch(0.65 0.2 25)" },
  amber: { label: "Amber", value: "oklch(0.75 0.16 70)" },
  orange: { label: "Orange", value: "oklch(0.7 0.17 48)" },
  emerald: { label: "Emerald", value: "oklch(0.7 0.15 162)" },
  sky: { label: "Sky", value: "oklch(0.7 0.14 237)" },
  violet: { label: "Violet", value: "oklch(0.65 0.2 293)" },
  pink: { label: "Pink", value: "oklch(0.68 0.19 354)" },
  slate: { label: "Slate", value: "oklch(0.6 0.02 257)" },
}

const DEFAULT_COLOR = "oklch(0.623 0.214 259.815)"

export function getPlaylistColor(key: string | null | undefined): string {
  if (!key) return DEFAULT_COLOR
  return PLAYLIST_COLORS[key]?.value ?? DEFAULT_COLOR
}
